var a = Object.defineProperty;
var c = (s, e, n) => e in s ? a(s, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : s[e] = n;
var t = (s, e, n) => c(s, typeof e != "symbol" ? e + "" : e, n);
import f from "./feed.mjs";
class d {
  constructor(e) {
    t(this, "instance");
    t(this, "feedInstances", []);
    this.instance = e;
  }
  initialize(e, n = {}) {
    const i = new f(this.instance, e, n);
    return this.feedInstances.push(i), i;
  }
  removeInstance(e) {
    this.feedInstances = this.feedInstances.filter((n) => n !== e);
  }
  teardownInstances() {
    for (const e of this.feedInstances)
      e.teardown();
  }
  reinitializeInstances() {
    for (const e of this.feedInstances)
      e.reinitialize();
  }
}
export {
  f as Feed,
  d as default
};
